import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { LocalStoreService } from '../common/local-store/local-store.service';
import { ApiService } from '../common/api/api.service';

@Injectable({
	providedIn: 'root'
})
export class AuthService {

	constructor(
		private api: ApiService,
		private router: Router,
		private localStore: LocalStoreService
	) { }

	isLoggedIn(): boolean {
		const token = this.localStore.getToken();
		return (token && token.length > 0)
	}
}
